<template>
  <v-container
    id="order-view"
    fluid
    tag="section"
  >
    <ViewAllOrders />
  </v-container>
</template>

<script>

//tänne sivulle käytetään ViewAllOrders komponenti, joka sisältää kaikki tilaukset
import ViewAllOrders from '@/components/ViewAllOrders'
import { sync } from 'vuex-pathify'

export default {
  name: 'Orders',
  components: {
    //rekisteröidään ViewAllOrder tämän komponentin sisällä
    ViewAllOrders
  },
  //Mounted hook, joka hakee dataa joka kerta kun komponenti aukea
  async mounted () {
    await this.getData()
  },
  computed: {
    ...sync('auth', [
      'admin'
    ])
  },
  methods: {
    //getData funktio joka laukea vuex storen sisäiset actions
    async getData() {
      //checkRole action tarkistaa käyttäjän rooli
      const resp = await this.$store.dispatch('auth/checkRole')

      if (this.admin) {
        //jos käyttäjä on admin, haetaan kaikki tilaukset
        await this.$store.dispatch('tables/fetchAdminOrders')
      } else {
        //sen jälkeen fetchData hakea käyttäjälle kuuluvaa dataa
        await this.$store.dispatch('tables/fetchData', resp)
      }
    }
  }
}
</script>
